<template>
  <div>
    <div class="status-hint" :class="{isloding:loading}">{{pageHint}}</div>
    <!-- <Loadstate v-if="loadstate" :tipText="pageHint"></Loadstate> -->
  </div>
</template>

<script>
// import Loadstate from "@/components/isloading.vue";
export default {
  components: {
    //Loadstate
  },
  data() {
    return {
      // loadstate: true,
      loading: true,
      pageHint: ''
    }
  },
  created() {
    const redirect = this.$getUrlKey('ReturnUrl')
    const wechatUser = this.$getUrlKey('WeiXinUser')
    const postUrl = '/api/Account/LoginByWechat?weixinUser=' + encodeURI(wechatUser)
    this.$post(postUrl)
      .then(result => {
        window.localStorage.setItem('ei_token', result)
        window.location.href = redirect
      })
      .catch(result => {
        if (result.Error.Code === 'UN_BIND_MOBILE') {
          this.$router.push(
            '/account/BindMobile?weixinUser=' +
              encodeURI(wechatUser) +
              '&returnUrl=' +
              encodeURI(redirect)
          )
        } else {
          this.$dialog.toast({
            mes: result.Error.Message,
            timeout: 2500
          })
        }
      })
  }
}
</script>
